import { render, staticRenderFns } from "./OrganizationModuleDetails.vue?vue&type=template&id=13c44a6c&scoped=true"
import script from "./OrganizationModuleDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationModuleDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganizationModuleDetails.vue?vue&type=style&index=0&id=13c44a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c44a6c",
  null
  
)

export default component.exports